import { constant } from 'common/constant';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: require('./common/locales/en/translation.json'),
            },
            hi: {
                translation: require('./common/locales/hi/translation.json'),
            },
        },
        lng: constant.langugageSelector.en,
        fallbackLng: constant.langugageSelector.en,
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['cookie'],
        },
    });

export default i18n;
